
const getEnvName = function (location) {
  const host = location.host
  // our urls are like 'dev-monitoring.creditsafe.com'
  // 'test-monitoring.creditsafe.com'
  // so get the text until the '-' to get the environment.
  const hyphenIndex = host.indexOf('-')
  const env = host.substr(0, hyphenIndex)
  return env || (host.indexOf('localhost') > -1 ? 'test' : 'live')
}

export default getEnvName



// WEBPACK FOOTER //
// ./src/env-util.js